import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  class: "_fw-eb _ffb",
  "format-key": "0"
}
const _hoisted_3 = {
  class: "_fw-eb _ffb",
  "format-key": "0"
}
const _hoisted_4 = { class: "_mt-3" }
const _hoisted_5 = {
  class: "gfu-project-update__actions",
  "data-qa": "project-update-single-page-actions"
}
const _hoisted_6 = { class: "gfu-project-update__actions--left" }
const _hoisted_7 = { class: "gfu-project-update__actions--right" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_project_updates_nav_buttons = _resolveComponent("project-updates-nav-buttons")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")
  const _component_project_update_banner = _resolveComponent("project-update-banner")
  const _component_richtext_article = _resolveComponent("richtext-article")
  const _component_poll = _resolveComponent("poll")
  const _component_like_action = _resolveComponent("like-action")
  const _component_social_media_actions = _resolveComponent("social-media-actions")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-box gfu-box--thick",
    "data-qa": `project-update-single-page-box:${$props.update.projectUpdateID}`
  }, [
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"]),
    ($options.hasNavButtons)
      ? (_openBlock(), _createBlock(_component_project_updates_nav_buttons, {
          key: 0,
          class: "_mb-4 _mb-8--m",
          "previous-update-url": $props.update.previousUpdateUrl,
          "next-update-url": $props.update.nextUpdateUrl,
          "data-qa": "project-update-nav:top"
        }, null, 8 /* PROPS */, ["previous-update-url", "next-update-url"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_project_update_banner, {
      update: $props.update,
      "show-info": false
    }, _createSlots({
      date: _withCtx(() => [
        ($props.update.updatedAt && $props.update.publishedAt)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              class: "_mr-1"
            }, {
              content: _withCtx(() => [
                _createVNode(_component_localize, {
                  tag: "div",
                  resource: _ctx.Resources.ProjectUpdates.OriginallyPublished
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString($options.publishedAtFormatted), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"]),
                _createVNode(_component_localize, {
                  tag: "div",
                  resource: _ctx.Resources.ProjectUpdates.LastModified
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString($options.updatedAtFormatted), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_base_icon, { name: "circle-info" })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("span", null, _toDisplayString($options.singleDateFormatted), 1 /* TEXT */)
      ]),
      _: 2 /* DYNAMIC */
    }, [
      ($options.isBadgeVisible)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createVNode(_component_tooltip, {
                text: _ctx.Resources.ProjectUpdates.UpdateStatusDraftParagraph
              }, {
                default: _withCtx(() => [
                  ($options.isDraft)
                    ? (_openBlock(), _createBlock(_component_base_badge, {
                        key: 0,
                        theme: "light",
                        "data-qa": "badge:Draft"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Resources.ProjectUpdates.UpdateStatusDraftBadge), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : ($options.isScheduled)
                      ? (_openBlock(), _createBlock(_component_base_badge, {
                          key: 1,
                          theme: "info",
                          "data-qa": "badge:Scheduled"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectUpdates.UpdateStatusScheduledBadge), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["text"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["update"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_richtext_article, {
        content: $props.update.content
      }, null, 8 /* PROPS */, ["content"]),
      ($props.update.pollID)
        ? (_openBlock(), _createBlock(_component_poll, {
            key: 0,
            "poll-i-d": $props.update.pollID,
            class: "_mt-6",
            onError: $options.handleError,
            "data-qa": "project-update-single-page:Poll"
          }, null, 8 /* PROPS */, ["poll-i-d", "onError"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_like_action, {
            enabled: $props.isLoggedIn,
            "is-liked": _ctx.isLikeButtonHighlighted,
            "likes-count": $props.update.likesCount,
            onLike: $options.toggleLikeUpdate
          }, null, 8 /* PROPS */, ["enabled", "is-liked", "likes-count", "onLike"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_social_media_actions, { class: "gfu-project-update__actions-icons" })
        ])
      ]),
      ($options.hasNavButtons)
        ? (_openBlock(), _createBlock(_component_project_updates_nav_buttons, {
            key: 1,
            class: "_mt-4 _mt-8--m",
            "previous-update-url": $props.update.previousUpdateUrl,
            "next-update-url": $props.update.nextUpdateUrl,
            "data-qa": "project-update-nav:bottom"
          }, null, 8 /* PROPS */, ["previous-update-url", "next-update-url"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}